import { RouteConfig } from "vue-router";

const cajaChicas: RouteConfig = {
  path: "/cajaChicas",
  name: "cajaChicas",
  component: () => import(/* webpackChunkName: "caja-chicas" */ "@/views/CajaChicas.vue"),
};

export default cajaChicas;
